import { VoucherApi } from '@/api/voucher'

const state = () => ({
  coupons: [],
  couponsPagination: {
    page: 1,
    perPage: 10,
    total: 0,
    from: 1,
  },
  coupon: null,
  isLoadingCoupon: false,
  isSuccessCoupon: true,
  messageCoupon: '',
})

const getters = {
  couponsList: state => state.coupons,
  couponsPagination: state => state.couponsPagination,
  couponDetail: state => state.coupon,
  isLoadingCoupon: state => state.isLoadingCoupon,
  isSuccessCoupon: state => state.isSuccessCoupon,
  messageCoupon: state => state.messageCoupon,
}

const actions = {
  async fetchCoupons({commit}, query = null) {
    let page = 1
    let perPage = 10
    let code = ''
    if (query !== null) {
        page = query.page
        perPage = query.perPage
        code = query.code
    }
    commit('setLoadingCoupon', true)
    await VoucherApi.getAllCoupon(perPage, page, code)
    .then(response => { 
      commit('setCoupons', response.data.data)
      const pagination = {
        page: response.data.pages.current_page,
        perPage: response.data.pages.per_page,
        total: response.data.pages.total,
        from: response.data.pages.from,
      }
      commit('setSuccessCoupon', true)
      commit('setCouponsPagination', pagination)
      commit('setLoadingCoupon', false)
    })
    .catch(error => {
      console.log(error)
      commit('setSuccessCoupon', false)
      commit('setMessageCoupon', error)
      commit('setLoadingCoupon', false)
    })
  },
  async deleteCoupon({commit}, id) {
    await VoucherApi.removeCoupon(id)
    .then(res => {
      if(res.data.success) {
        commit('setSuccessCoupon', true)
        commit('setMessageCoupon', 'Berhasil Menghapus Kupon')
      } else {
        commit('setSuccessCoupon', false)
        commit('setMessageCoupon', 'Terjadi Kesalahan')
      }
    })
    .catch(error => {
      commit('setMessageCoupon', error)
      commit('setSuccessCoupon', false)
    })
  },
  async fetchDetailCoupon({commit}, id) {
    commit('setLoadingCoupon', true)
    await VoucherApi.detailCoupon(id)
    .then(res => {
      commit('setLoadingCoupon', false)
      commit('setCouponDetail', res.data.data)
      commit('setSuccessCoupon', true)
    })
    .catch(error => {
      commit('setLoadingCoupon', false)
      commit('setMessageCoupon', error)
      commit('setSuccessCoupon', false)
    })
  },
  async addCoupon({commit}, payload) {
    await VoucherApi.addCoupon(payload)
    .then(res => {
      if(res.data.success) {
        commit('setSuccessCoupon', true)
        commit('setMessageCoupon', 'Berhasil Tambah Kupon')
      } else {
        commit('setSuccessCoupon', false)
        commit('setMessageCoupon', 'Terjadi Kesalahan')
      }
    })
    .catch(error => {
      commit('setSuccessCoupon', false)
      commit('setMessageCoupon', error)
    })
  },
  async updateCoupon({commit}, data) {
    const id = data.id
    const payload = data.payload
    await VoucherApi.updateCoupon(id, payload)
    .then(res => {
      if(res.data.success) {
        commit('setSuccessCoupon', true)
        commit('setMessageCoupon', 'Berhasil Update Kupon')
      } else {
        commit('setSuccessCoupon', false)
        commit('setMessageCoupon', 'Terjadi Kesalahan')
      }
    })
    .catch(error => {
      commit('setSuccessCoupon', false)
      commit('setMessageCoupon', error)
    })
  }
}

const mutations = {
  setCoupons: (state, coupons) => {
    state.coupons = coupons
  },

  setCouponsPagination: (state, couponsPagination) => {
    state.couponsPagination = couponsPagination
  },

  setCouponDetail: (state, coupon) => {
    state.coupon = coupon
  },

  setLoadingCoupon: (state, isLoading) => {
    state.isLoadingCoupon = isLoading
  },

  setSuccessCoupon: (state, isSuccess) => {
    state.isSuccessCoupon = isSuccess
  },

  setMessageCoupon: (state, message) => {
    state.messageCoupon = message
  }, 
}

export default {
  state,
  getters,
  actions,
  mutations
}